module.exports = require("react-router");


//////////////////
// WEBPACK FOOTER
// external "react-router"
// module id = 18
// module chunks = 0